import { useState } from "react";
import { usePWAInstall } from "../utils/usePWAInstall";
import { useLanguage } from "../context/LanguageContext";

function MobileInstallBanner() {
  const { canInstall, isIOS, isInStandalone, installed, install } = usePWAInstall();
  const [dismissed, setDismissed] = useState(false);
  const { t } = useLanguage();

  if (isInStandalone || installed || dismissed) return null;
  if (!canInstall && !isIOS) return null;

  return (
    <div className="mx-3 mb-4">
      <div
        style={{
          background: "linear-gradient(135deg, #c20e1a 0%, #e8222e 100%)",
          borderRadius: 20,
          padding: "16px 18px",
          position: "relative",
        }}
      >
        <button
          className="position-absolute border-0 bg-transparent"
          style={{ top: 8, right: 10, color: "rgba(255,255,255,0.5)", fontSize: "0.75rem" }}
          onClick={() => setDismissed(true)}
        >
          <i className="bi bi-x-lg"></i>
        </button>

        <div className="d-flex align-items-center gap-3 mb-3">
          <i className="bi bi-phone-fill text-white" style={{ fontSize: "1.6rem", flexShrink: 0 }}></i>
          <div>
            <div className="text-white fw-bold" style={{ fontSize: "0.9rem", lineHeight: 1.3 }}>
              {t("pwa.mobileTitle")}
            </div>
            <div style={{ color: "rgba(255,255,255,0.75)", fontSize: "0.72rem", lineHeight: 1.3, marginTop: 2 }}>
              {t("pwa.mobileSubtitle")}
            </div>
          </div>
        </div>

        {canInstall ? (
          <button
            className="btn w-100 fw-bold"
            style={{
              background: "#fff",
              color: "#c20e1a",
              borderRadius: 28,
              padding: "9px",
              fontSize: "0.85rem",
              border: "none",
            }}
            onClick={install}
          >
            <i className="bi bi-download me-2"></i>
            {t("pwa.mobileInstall")}
          </button>
        ) : isIOS ? (
          <div
            className="rounded-pill text-center py-2"
            style={{ background: "rgba(255,255,255,0.15)", fontSize: "0.78rem", color: "rgba(255,255,255,0.9)" }}
          >
            <i className="bi bi-box-arrow-up me-1"></i>
            {t("pwa.iosHintShort")}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default MobileInstallBanner;
